import { c as _c } from "react/compiler-runtime";
import { Badge } from '@common/components';
import { SvgChevronright } from '@common/icon';
import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';
interface BenefitMenuRowProps {
  imageUrl?: string;
  title: string;
  description?: string;
  isNew: boolean;
  isPopular: boolean;
  //* url 항목은 링크 이동, placementKey 항목은 onSelect로 오퍼월을 연다. 둘 다 없으면 비활성.
  href?: string;
  onSelect?: () => void;
}
const ROW_CLASS_NAME = 'group -mx-8 flex w-full items-center justify-between rounded-xsmall px-8 py-12 transition-colors focus-visible:bg-Gray-25 active:bg-Gray-50 xl:hover:bg-Gray-25';
const RowChevron = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SvgChevronright className="size-16 shrink-0 text-Gray-400 transition group-focus-visible:translate-x-1 group-focus-visible:text-Gray-600 xl:group-hover:translate-x-1 xl:group-hover:text-Gray-600" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export const BenefitMenuRow = t0 => {
  const $ = _c(30);
  const {
    imageUrl,
    title,
    description,
    isNew,
    isPopular,
    href,
    onSelect
  } = t0;
  let t1;
  if ($[0] !== imageUrl) {
    t1 = <Image src={imageUrl} alt="" width={40} height={40} sizes="40px" className="size-40 shrink-0 rounded-small object-cover" />;
    $[0] = imageUrl;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title) {
    t2 = <p className="font-600 text-Gray-900 typo-body4">{title}</p>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== isNew) {
    t3 = isNew ? <Badge className="bg-O-50 text-O-550">NEW</Badge> : null;
    $[4] = isNew;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== isPopular) {
    t4 = isPopular ? <Badge className="bg-R-50 text-R-500">인기</Badge> : null;
    $[6] = isPopular;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = <div className="flex items-center gap-8">{t2}{t3}{t4}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== description) {
    t6 = description ? <p className="break-keep font-600 text-Gray-600 typo-caption1">{description}</p> : null;
    $[12] = description;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5 || $[15] !== t6) {
    t7 = <div className="flex flex-col items-start">{t5}{t6}</div>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t1 || $[18] !== t7) {
    t8 = <div className="flex items-center gap-16">{t1}{t7}</div>;
    $[17] = t1;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  const info = t8;
  if (href) {
    let t9;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <RowChevron />;
      $[20] = t9;
    } else {
      t9 = $[20];
    }
    let t10;
    if ($[21] !== href || $[22] !== info) {
      t10 = <CustomLink href={href} className={ROW_CLASS_NAME}>{info}{t9}</CustomLink>;
      $[21] = href;
      $[22] = info;
      $[23] = t10;
    } else {
      t10 = $[23];
    }
    return t10;
  }
  if (onSelect) {
    let t9;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <RowChevron />;
      $[24] = t9;
    } else {
      t9 = $[24];
    }
    let t10;
    if ($[25] !== info || $[26] !== onSelect) {
      t10 = <button onClick={onSelect} className={ROW_CLASS_NAME}>{info}{t9}</button>;
      $[25] = info;
      $[26] = onSelect;
      $[27] = t10;
    } else {
      t10 = $[27];
    }
    return t10;
  }
  let t9;
  if ($[28] !== info) {
    t9 = <div aria-disabled="true" className="flex items-center justify-between rounded-xsmall py-12 opacity-50">{info}</div>;
    $[28] = info;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  return t9;
};